import type { BuildingListSections } from "../../../types/buildings-sections/list";

export const buildingList: BuildingListSections = {
  addNewBuilding: "Add New Building",
  emptyTitle: "No buildings found",
  emptyDescription: "Create your first building to get started!",
  errorTitle: "Error loading buildings",
  failedToLoad: "Failed to load buildings",
  tryAgain: "Try again",
  goHome: "Go home",
  archivedTitle: "Archived buildings",
  viewActive: "View active",
  viewArchived: "View archived",
  noBuildingsIntro: "You don't have any buildings yet.",
  createNewLink: "Create new building",
  getStartedSuffix: "to get started.",
  active: "Active",
  archived: "Archived",
  searchPlaceholder: "Search buildings and projects...",
  searchArchivedPlaceholder: "Search archived buildings...",
  noSearchResults: "No buildings or projects match your search.",
  noProjectsInBuilding: "No projects in this building yet.",
  addProjectLink: "+ Add project",
  expandProjects: "Show projects",
  collapseProjects: "Hide projects",
  defaultProjectBadge: "Default",
  docsLabel: "documents",
  issuesLabel: "open issues",
  membersLabel: "members",
  projectsCount: "Projects · {count}",
  projectsLoadFailed: "Projects could not be loaded.",
  newActivity: "New activity",
  buildingActions: "Building actions",
  sortBy: "Sort by",
  sortOptions: {
    nameAsc: "Name A–Z",
    nameDesc: "Name Z–A",
    addressAsc: "Address A–Z",
    addressDesc: "Address Z–A",
    registryAsc: "Registry code",
    areaDesc: "Largest net area",
    areaAsc: "Smallest net area",
  },
};
